import { graphql } from "~/lib/graphql";

export const publicationTeaserFragment = graphql(`
  fragment publicationTeaserFragment on PublicationTeaserRecord {
    __typename
    id
    abstract(markdown: false)
    ctaUrl
    ctaLabel
    file {
      url
      title
    }
    subtitle
    pretitle
    title
    cover {
      id
      height
      width
      url
    }
  }
`);
